import {
  Companion_getInstance47wfz1otatcx as Companion_getInstance,
  IncidentResponseTypeSerializable3r9ni9dqtxaoj as IncidentResponseTypeSerializable,
  IncidentResponseTypeType1fxfyyj6j6wn1 as IncidentResponseTypeType,
} from './serialization.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ClientConcern1skfmbxl86a3t as ClientConcern } from './IncidentResponseType.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  AccessInfoj60d6hx1qs8r as AccessInfo,
} from '../supportModels.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareIncidentResponseTypeSerializableFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [IncidentResponseTypeSerializable_type_getInstance(), IncidentResponseTypeSerializable_concern_getInstance(), IncidentResponseTypeSerializable_raiseIssue_getInstance(), IncidentResponseTypeSerializable_fileDispute_getInstance(), IncidentResponseTypeSerializable_proposingResolution_getInstance(), IncidentResponseTypeSerializable_credit_getInstance(), IncidentResponseTypeSerializable_due_getInstance(), IncidentResponseTypeSerializable_proposal_getInstance(), IncidentResponseTypeSerializable_remedy_getInstance(), IncidentResponseTypeSerializable_accessInfo_getInstance(), IncidentResponseTypeSerializable_time_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function IncidentResponseTypeSerializable_type$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function IncidentResponseTypeSerializable_type$_get_name_$ref_tof0hm() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_type$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_type$_get_serializer_$ref_u1iqzj() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_type$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function IncidentResponseTypeSerializable_type$_get_annotations_$ref_870jln() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_typeClass;
function IncidentResponseTypeSerializable_type() {
  if (IncidentResponseTypeSerializable_typeClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_type_instance = this;
        var tmp = this;
        tmp.q8f_1 = lazy(IncidentResponseTypeSerializable_type$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r8f_1 = lazy(IncidentResponseTypeSerializable_type$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s8f_1 = lazy(IncidentResponseTypeSerializable_type$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.q8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_type$_get_name_$ref_tof0hm(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.u8f_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      f8g(receiver, value) {
        return receiver.g8g(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.f8g(tmp, value instanceof IncidentResponseTypeType() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_type$_get_serializer_$ref_u1iqzj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_type$_get_annotations_$ref_870jln(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_type', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_typeClass = $;
  }
  return IncidentResponseTypeSerializable_typeClass;
}
var IncidentResponseTypeSerializable_type_instance;
function IncidentResponseTypeSerializable_type_getInstance() {
  if (IncidentResponseTypeSerializable_type_instance === VOID)
    new (IncidentResponseTypeSerializable_type())();
  return IncidentResponseTypeSerializable_type_instance;
}
function IncidentResponseTypeSerializable_concern$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function IncidentResponseTypeSerializable_concern$_get_name_$ref_afbfru() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_concern$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_concern$_get_serializer_$ref_i6iojj() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_concern$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function IncidentResponseTypeSerializable_concern$_get_annotations_$ref_kqidi3() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_concernClass;
function IncidentResponseTypeSerializable_concern() {
  if (IncidentResponseTypeSerializable_concernClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_concern_instance = this;
        var tmp = this;
        tmp.h8g_1 = lazy(IncidentResponseTypeSerializable_concern$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i8g_1 = lazy(IncidentResponseTypeSerializable_concern$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j8g_1 = lazy(IncidentResponseTypeSerializable_concern$annotations$delegate$lambda);
        this.k8g_1 = null;
        this.l8g_1 = 'null';
      }
      k20() {
        var tmp0 = this.h8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_concern$_get_name_$ref_afbfru(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.v8f_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      m8g(receiver, value) {
        return receiver.g8g(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.m8g(tmp, (value == null ? true : value instanceof ClientConcern()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_concern$_get_serializer_$ref_i6iojj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_concern$_get_annotations_$ref_kqidi3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_concern', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_concernClass = $;
  }
  return IncidentResponseTypeSerializable_concernClass;
}
var IncidentResponseTypeSerializable_concern_instance;
function IncidentResponseTypeSerializable_concern_getInstance() {
  if (IncidentResponseTypeSerializable_concern_instance === VOID)
    new (IncidentResponseTypeSerializable_concern())();
  return IncidentResponseTypeSerializable_concern_instance;
}
function IncidentResponseTypeSerializable_raiseIssue$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function IncidentResponseTypeSerializable_raiseIssue$_get_name_$ref_5sz91v() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_raiseIssue$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_raiseIssue$_get_serializer_$ref_z66mgc() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_raiseIssue$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function IncidentResponseTypeSerializable_raiseIssue$_get_annotations_$ref_8rbfx4() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_raiseIssueClass;
function IncidentResponseTypeSerializable_raiseIssue() {
  if (IncidentResponseTypeSerializable_raiseIssueClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_raiseIssue_instance = this;
        var tmp = this;
        tmp.n8g_1 = lazy(IncidentResponseTypeSerializable_raiseIssue$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o8g_1 = lazy(IncidentResponseTypeSerializable_raiseIssue$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p8g_1 = lazy(IncidentResponseTypeSerializable_raiseIssue$annotations$delegate$lambda);
        this.q8g_1 = false;
        this.r8g_1 = 'false';
      }
      k20() {
        var tmp0 = this.n8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_raiseIssue$_get_name_$ref_5sz91v(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.w8f_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      s8g(receiver, value) {
        return receiver.g8g(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.s8g(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_raiseIssue$_get_serializer_$ref_z66mgc(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_raiseIssue$_get_annotations_$ref_8rbfx4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_raiseIssue', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_raiseIssueClass = $;
  }
  return IncidentResponseTypeSerializable_raiseIssueClass;
}
var IncidentResponseTypeSerializable_raiseIssue_instance;
function IncidentResponseTypeSerializable_raiseIssue_getInstance() {
  if (IncidentResponseTypeSerializable_raiseIssue_instance === VOID)
    new (IncidentResponseTypeSerializable_raiseIssue())();
  return IncidentResponseTypeSerializable_raiseIssue_instance;
}
function IncidentResponseTypeSerializable_fileDispute$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function IncidentResponseTypeSerializable_fileDispute$_get_name_$ref_drfzku() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_fileDispute$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_fileDispute$_get_serializer_$ref_y9d87() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_fileDispute$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function IncidentResponseTypeSerializable_fileDispute$_get_annotations_$ref_dedbjh() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_fileDisputeClass;
function IncidentResponseTypeSerializable_fileDispute() {
  if (IncidentResponseTypeSerializable_fileDisputeClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_fileDispute_instance = this;
        var tmp = this;
        tmp.t8g_1 = lazy(IncidentResponseTypeSerializable_fileDispute$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u8g_1 = lazy(IncidentResponseTypeSerializable_fileDispute$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v8g_1 = lazy(IncidentResponseTypeSerializable_fileDispute$annotations$delegate$lambda);
        this.w8g_1 = false;
        this.x8g_1 = 'false';
      }
      k20() {
        var tmp0 = this.t8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_fileDispute$_get_name_$ref_drfzku(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.x8f_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      s8g(receiver, value) {
        return receiver.g8g(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.s8g(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_fileDispute$_get_serializer_$ref_y9d87(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_fileDispute$_get_annotations_$ref_dedbjh(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_fileDispute', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_fileDisputeClass = $;
  }
  return IncidentResponseTypeSerializable_fileDisputeClass;
}
var IncidentResponseTypeSerializable_fileDispute_instance;
function IncidentResponseTypeSerializable_fileDispute_getInstance() {
  if (IncidentResponseTypeSerializable_fileDispute_instance === VOID)
    new (IncidentResponseTypeSerializable_fileDispute())();
  return IncidentResponseTypeSerializable_fileDispute_instance;
}
function IncidentResponseTypeSerializable_proposingResolution$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function IncidentResponseTypeSerializable_proposingResolution$_get_name_$ref_fto1i7() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_proposingResolution$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_proposingResolution$_get_serializer_$ref_dahqgo() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_proposingResolution$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function IncidentResponseTypeSerializable_proposingResolution$_get_annotations_$ref_u93m0k() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_proposingResolutionClass;
function IncidentResponseTypeSerializable_proposingResolution() {
  if (IncidentResponseTypeSerializable_proposingResolutionClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_proposingResolution_instance = this;
        var tmp = this;
        tmp.y8g_1 = lazy(IncidentResponseTypeSerializable_proposingResolution$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z8g_1 = lazy(IncidentResponseTypeSerializable_proposingResolution$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a8h_1 = lazy(IncidentResponseTypeSerializable_proposingResolution$annotations$delegate$lambda);
        this.b8h_1 = false;
        this.c8h_1 = 'false';
      }
      k20() {
        var tmp0 = this.y8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_proposingResolution$_get_name_$ref_fto1i7(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.y8f_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      s8g(receiver, value) {
        return receiver.g8g(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.s8g(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z8g_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_proposingResolution$_get_serializer_$ref_dahqgo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_proposingResolution$_get_annotations_$ref_u93m0k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_proposingResolution', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_proposingResolutionClass = $;
  }
  return IncidentResponseTypeSerializable_proposingResolutionClass;
}
var IncidentResponseTypeSerializable_proposingResolution_instance;
function IncidentResponseTypeSerializable_proposingResolution_getInstance() {
  if (IncidentResponseTypeSerializable_proposingResolution_instance === VOID)
    new (IncidentResponseTypeSerializable_proposingResolution())();
  return IncidentResponseTypeSerializable_proposingResolution_instance;
}
function IncidentResponseTypeSerializable_credit$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function IncidentResponseTypeSerializable_credit$_get_name_$ref_qw86xl() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_credit$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_credit$_get_serializer_$ref_cgvpts() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_credit$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function IncidentResponseTypeSerializable_credit$_get_annotations_$ref_fa1w90() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_creditClass;
function IncidentResponseTypeSerializable_credit() {
  if (IncidentResponseTypeSerializable_creditClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_credit_instance = this;
        var tmp = this;
        tmp.d8h_1 = lazy(IncidentResponseTypeSerializable_credit$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e8h_1 = lazy(IncidentResponseTypeSerializable_credit$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f8h_1 = lazy(IncidentResponseTypeSerializable_credit$annotations$delegate$lambda);
        this.g8h_1 = null;
        this.h8h_1 = 'null';
      }
      k20() {
        var tmp0 = this.d8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_credit$_get_name_$ref_qw86xl(), null);
        return tmp0.f2();
      }
      i8h(receiver) {
        return receiver.z8f_1;
      }
      m2j(receiver) {
        var tmp = this.i8h(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }
      j8h(receiver, value) {
        return receiver.g8g(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof MonetaryValue()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.a5s_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.j8h(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.e8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_credit$_get_serializer_$ref_cgvpts(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_credit$_get_annotations_$ref_fa1w90(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_credit', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_creditClass = $;
  }
  return IncidentResponseTypeSerializable_creditClass;
}
var IncidentResponseTypeSerializable_credit_instance;
function IncidentResponseTypeSerializable_credit_getInstance() {
  if (IncidentResponseTypeSerializable_credit_instance === VOID)
    new (IncidentResponseTypeSerializable_credit())();
  return IncidentResponseTypeSerializable_credit_instance;
}
function IncidentResponseTypeSerializable_due$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function IncidentResponseTypeSerializable_due$_get_name_$ref_ia7kz2() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_due$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_due$_get_serializer_$ref_aqtxud() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_due$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function IncidentResponseTypeSerializable_due$_get_annotations_$ref_5y327t() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_dueClass;
function IncidentResponseTypeSerializable_due() {
  if (IncidentResponseTypeSerializable_dueClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_due_instance = this;
        var tmp = this;
        tmp.k8h_1 = lazy(IncidentResponseTypeSerializable_due$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l8h_1 = lazy(IncidentResponseTypeSerializable_due$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m8h_1 = lazy(IncidentResponseTypeSerializable_due$annotations$delegate$lambda);
        this.n8h_1 = null;
        this.o8h_1 = 'null';
      }
      k20() {
        var tmp0 = this.k8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_due$_get_name_$ref_ia7kz2(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.a8g_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      p8h(receiver, value) {
        return receiver.g8g(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.p8h(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_due$_get_serializer_$ref_aqtxud(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_due$_get_annotations_$ref_5y327t(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_due', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_dueClass = $;
  }
  return IncidentResponseTypeSerializable_dueClass;
}
var IncidentResponseTypeSerializable_due_instance;
function IncidentResponseTypeSerializable_due_getInstance() {
  if (IncidentResponseTypeSerializable_due_instance === VOID)
    new (IncidentResponseTypeSerializable_due())();
  return IncidentResponseTypeSerializable_due_instance;
}
function IncidentResponseTypeSerializable_proposal$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function IncidentResponseTypeSerializable_proposal$_get_name_$ref_owenaq() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_proposal$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_proposal$_get_serializer_$ref_33nk7t() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_proposal$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function IncidentResponseTypeSerializable_proposal$_get_annotations_$ref_tt8mpp() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_proposalClass;
function IncidentResponseTypeSerializable_proposal() {
  if (IncidentResponseTypeSerializable_proposalClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_proposal_instance = this;
        var tmp = this;
        tmp.q8h_1 = lazy(IncidentResponseTypeSerializable_proposal$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r8h_1 = lazy(IncidentResponseTypeSerializable_proposal$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s8h_1 = lazy(IncidentResponseTypeSerializable_proposal$annotations$delegate$lambda);
        this.t8h_1 = null;
        this.u8h_1 = 'null';
      }
      k20() {
        var tmp0 = this.q8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_proposal$_get_name_$ref_owenaq(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.b8g_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      v8h(receiver, value) {
        return receiver.g8g(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.v8h(tmp, (value == null ? true : value instanceof IncidentResponseTypeSerializable()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_proposal$_get_serializer_$ref_33nk7t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_proposal$_get_annotations_$ref_tt8mpp(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_proposal', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_proposalClass = $;
  }
  return IncidentResponseTypeSerializable_proposalClass;
}
var IncidentResponseTypeSerializable_proposal_instance;
function IncidentResponseTypeSerializable_proposal_getInstance() {
  if (IncidentResponseTypeSerializable_proposal_instance === VOID)
    new (IncidentResponseTypeSerializable_proposal())();
  return IncidentResponseTypeSerializable_proposal_instance;
}
function IncidentResponseTypeSerializable_remedy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function IncidentResponseTypeSerializable_remedy$_get_name_$ref_quj6jk() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_remedy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_remedy$_get_serializer_$ref_ix483r() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_remedy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function IncidentResponseTypeSerializable_remedy$_get_annotations_$ref_ydflxx() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_remedyClass;
function IncidentResponseTypeSerializable_remedy() {
  if (IncidentResponseTypeSerializable_remedyClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_remedy_instance = this;
        var tmp = this;
        tmp.w8h_1 = lazy(IncidentResponseTypeSerializable_remedy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x8h_1 = lazy(IncidentResponseTypeSerializable_remedy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y8h_1 = lazy(IncidentResponseTypeSerializable_remedy$annotations$delegate$lambda);
        this.z8h_1 = null;
        this.a8i_1 = 'null';
      }
      k20() {
        var tmp0 = this.w8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_remedy$_get_name_$ref_quj6jk(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.c8g_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      v8h(receiver, value) {
        return receiver.g8g(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.v8h(tmp, (value == null ? true : value instanceof IncidentResponseTypeSerializable()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_remedy$_get_serializer_$ref_ix483r(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y8h_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_remedy$_get_annotations_$ref_ydflxx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_remedy', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_remedyClass = $;
  }
  return IncidentResponseTypeSerializable_remedyClass;
}
var IncidentResponseTypeSerializable_remedy_instance;
function IncidentResponseTypeSerializable_remedy_getInstance() {
  if (IncidentResponseTypeSerializable_remedy_instance === VOID)
    new (IncidentResponseTypeSerializable_remedy())();
  return IncidentResponseTypeSerializable_remedy_instance;
}
function IncidentResponseTypeSerializable_accessInfo$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function IncidentResponseTypeSerializable_accessInfo$_get_name_$ref_qe0mxa() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_accessInfo$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_accessInfo$_get_serializer_$ref_kl63rt() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_accessInfo$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function IncidentResponseTypeSerializable_accessInfo$_get_annotations_$ref_f1xtoj() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_accessInfoClass;
function IncidentResponseTypeSerializable_accessInfo() {
  if (IncidentResponseTypeSerializable_accessInfoClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_accessInfo_instance = this;
        var tmp = this;
        tmp.b8i_1 = lazy(IncidentResponseTypeSerializable_accessInfo$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c8i_1 = lazy(IncidentResponseTypeSerializable_accessInfo$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d8i_1 = lazy(IncidentResponseTypeSerializable_accessInfo$annotations$delegate$lambda);
        this.e8i_1 = null;
        this.f8i_1 = 'null';
      }
      k20() {
        var tmp0 = this.b8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_accessInfo$_get_name_$ref_qe0mxa(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.d8g_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      g8i(receiver, value) {
        return receiver.g8g(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.g8i(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_accessInfo$_get_serializer_$ref_kl63rt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_accessInfo$_get_annotations_$ref_f1xtoj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_accessInfo', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_accessInfoClass = $;
  }
  return IncidentResponseTypeSerializable_accessInfoClass;
}
var IncidentResponseTypeSerializable_accessInfo_instance;
function IncidentResponseTypeSerializable_accessInfo_getInstance() {
  if (IncidentResponseTypeSerializable_accessInfo_instance === VOID)
    new (IncidentResponseTypeSerializable_accessInfo())();
  return IncidentResponseTypeSerializable_accessInfo_instance;
}
function IncidentResponseTypeSerializable_time$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function IncidentResponseTypeSerializable_time$_get_name_$ref_oya1g3() {
  return (p0) => p0.k20();
}
function IncidentResponseTypeSerializable_time$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function IncidentResponseTypeSerializable_time$_get_serializer_$ref_dzh4es() {
  return (p0) => p0.j2j();
}
function IncidentResponseTypeSerializable_time$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function IncidentResponseTypeSerializable_time$_get_annotations_$ref_ngrje0() {
  return (p0) => p0.bz();
}
var IncidentResponseTypeSerializable_timeClass;
function IncidentResponseTypeSerializable_time() {
  if (IncidentResponseTypeSerializable_timeClass === VOID) {
    class $ {
      constructor() {
        IncidentResponseTypeSerializable_time_instance = this;
        var tmp = this;
        tmp.h8i_1 = lazy(IncidentResponseTypeSerializable_time$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i8i_1 = lazy(IncidentResponseTypeSerializable_time$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j8i_1 = lazy(IncidentResponseTypeSerializable_time$annotations$delegate$lambda);
        this.k8i_1 = null;
        this.l8i_1 = 'null';
      }
      k20() {
        var tmp0 = this.h8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, IncidentResponseTypeSerializable_time$_get_name_$ref_oya1g3(), null);
        return tmp0.f2();
      }
      t8f(receiver) {
        return receiver.e8g_1;
      }
      m2j(receiver) {
        return this.t8f(receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE());
      }
      p8h(receiver, value) {
        return receiver.g8g(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof IncidentResponseTypeSerializable() ? receiver : THROW_CCE();
        return this.p8h(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, IncidentResponseTypeSerializable_time$_get_serializer_$ref_dzh4es(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j8i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, IncidentResponseTypeSerializable_time$_get_annotations_$ref_ngrje0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'IncidentResponseTypeSerializable_time', VOID, VOID, [SerializableProperty()]);
    IncidentResponseTypeSerializable_timeClass = $;
  }
  return IncidentResponseTypeSerializable_timeClass;
}
var IncidentResponseTypeSerializable_time_instance;
function IncidentResponseTypeSerializable_time_getInstance() {
  if (IncidentResponseTypeSerializable_time_instance === VOID)
    new (IncidentResponseTypeSerializable_time())();
  return IncidentResponseTypeSerializable_time_instance;
}
//region block: exports
export {
  prepareIncidentResponseTypeSerializableFields as prepareIncidentResponseTypeSerializableFields1f70ohdtw8frd,
};
//endregion

//# sourceMappingURL=IncidentResponseTypeSerializableFields.mjs.map
